
import categories from '~/services/categories'
import Product from './Product.vue'
export default {
  props: {
    selectedItems: {
      default: null,
    },
  },
  components: {
    Product,
  },
  data() {
    return {
      activeIndex: 0,
      categories: [],
    }
  },
  mounted() {
    this.categories = categories.getAll()
  },
}
